// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";


// 🔄 Replace these with your real Firebase config values
const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "YOUR_PROJECT_ID.firebaseapp.com",
//   projectId: "YOUR_PROJECT_ID",
//   storageBucket: "YOUR_PROJECT_ID.appspot.com",
//   messagingSenderId: "YOUR_SENDER_ID",
//   appId: "YOUR_APP_ID",
    apiKey: "AIzaSyCq2MMgk8oxzgMonj9vQFQzwp0ibzvZwKo",
    authDomain: "milkprofarmerapp.firebaseapp.com",
    projectId: "milkprofarmerapp",
    storageBucket: "milkprofarmerapp.firebasestorage.app",
    messagingSenderId: "723976256430",
    appId: "1:723976256430:web:ac7ca05b139360ffbc663f"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
